import { createCustomElement } from '@angular/elements';
import { enableProdMode } from '@angular/core';
import { createApplication } from '@angular/platform-browser';
import { AppComponent } from './app/app.component';

// eslint-disable-next-line
// @ts-ignore
// eslint-disable-next-line
if (process.env['NODE_ENV'] !== 'development') {
    enableProdMode();
}

void createApplication().then((application) => {
    const customElement = createCustomElement(AppComponent, {
        injector: application.injector,
    });

    customElements.define('global-home', customElement);
});
